import React from 'react'
import { Col, Container, Row, Dropdown } from 'react-bootstrap'
import { Sidebar } from '../../Components/Sidebar'
import { BsChevronLeft, BsQuestionCircle } from "react-icons/bs";
import { Link } from 'react-router-dom';
import { AddConsentForm } from '../../Components/Consent/AddConsentForm';
import { consentForm } from '../../data/initialData';
import { useAuth } from '../../contexts/auth';

export const NewConsent = () => {
    const baseURL = process.env.REACT_APP_BASE_URL;
    const { user } = useAuth();
    return (
        <div className='new-consent-page'>
        <Container fluid className='px-4 py-5'>
            <Row>
                {/* This link will now ONLY appear if the user has consents */}
                {user?.hasConsents && (
                    <Link to={'/home'} className='fw-bold mb-4 d-inline-block text-decoration-none'>
                        <BsChevronLeft className='me-1' />Back
                    </Link>
                )}
                <Col md={3}>
                    <Sidebar
                        title={'New consent'}
                        gradientBg={true}
                        helpLinks={[
                            { text: 'FAQ', url: '/faq' },
                            { text: 'Add a new GSP on E-Way Bill Portal', url: `${baseURL}/static/tc/eway-bill-portal.pdf` }
                        ]}
                        highlightHelp={true}
                    />
                </Col>
                <Col md={7} className='offset-1'>
                    {/* <Link to={'/home'} className='fw-bold mt-4 mb-5 d-inline-block text-decoration-none ms-n1'>
                        <BsChevronLeft className='me-1' />Back
                    </Link> */}
                    <AddConsentForm initialData={consentForm} type="create"/>
                </Col>
            </Row>
        </Container>
        {/* Fixed Help Button */}
        {/*
        <div className="fixed-help-button">
            <Dropdown align="end">
                <Dropdown.Toggle id="help-dropdown" className="help-button">
                    <BsQuestionCircle size={24} />
                    <span className="help-text ms-2">Help</span>
                </Dropdown.Toggle>

                <Dropdown.Menu className="help-dropdown-menu">
                    {/* <Dropdown.Item 
                        href="https://youtube.com" 
                        target="_blank"
                        className="help-dropdown-item"
                    >
                        <span className="fw-semibold">Need help? Watch a video</span>
                    </Dropdown.Item>
                    <Dropdown.Divider /> 
                    <Dropdown.Item 
                        as={Link} 
                        to="/faq"
                        className="help-dropdown-item"
                    >
                        <span className="fw-semibold">FAQ</span>
                    </Dropdown.Item>
                </Dropdown.Menu>
            </Dropdown>
        </div>
        */}
    </div>
    )
}
